import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { SelectOption } from '@shared/components/form/form-select/select-option.model';


export const monthList: SelectOption[] = [
    {
        id: 1,
        name: marker('data.months.1'),
    },
    {
        id: 2,
        name: marker('data.months.2'),
    },
    {
        id: 3,
        name: marker('data.months.3'),
    },
    {
        id: 4,
        name: marker('data.months.4'),
    },
    {
        id: 5,
        name: marker('data.months.5'),
    },
    {
        id: 6,
        name: marker('data.months.6'),
    },
    {
        id: 7,
        name: marker('data.months.7'),
    },
    {
        id: 8,
        name: marker('data.months.8'),
    },
    {
        id: 9,
        name: marker('data.months.9'),
    },
    {
        id: 10,
        name: marker('data.months.10'),
    },
    {
        id: 11,
        name: marker('data.months.11'),
    },
    {
        id: 12,
        name: marker('data.months.12'),
    },
];
